import React from "react";
import { ImageWrapper } from './styles';

import {
  Container,
  List,
  ListItem,
  Wrapper,
  SmallTitle,
  Title,
  TechnologiesItem,
  TechnologiesWrapper,
  Text,
  TextBox,
} from "./styles";

export const WhatWeDid = ({ data, color }) => {
  return (
    <Container color={color}>
      <Wrapper>
        <Title>{data.title}</Title>
        {data.technologies && (
          <TechnologiesWrapper>
            {data.technologies.map((element, i) => (
              <TechnologiesItem key={i}>{element}</TechnologiesItem>
            ))}
          </TechnologiesWrapper>
        )}
        <TextBox>
          <SmallTitle>Co zrobiliśmy</SmallTitle>
          {data.text && <Text>{data.text}</Text>}

          {data.list && (
            <List>
              {data.list.map((item, i) => (
                <ListItem key={i}>{item}</ListItem>
              ))}
            </List>
          )}

          {data.image && (
            <ImageWrapper width={data.imageWidth}>{data.image}</ImageWrapper>
          )}
        </TextBox>
      </Wrapper>
    </Container>
  );
};
